var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSecureFolder = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#85C7F6",
    fillRule: "evenodd",
    d: "M26 27.333H6c-1.837 0-3.333-1.454-3.333-3.242V7.909c0-1.788 1.496-3.242 3.333-3.242h6.135c.398 0 .778.18 1.032.49l3.465 4.238H26c1.837 0 3.333 1.454 3.333 3.242v11.454c0 1.788-1.496 3.242-3.333 3.242z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSecureFolder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/secure_folder.d9d7f9a0.svg";
export { ForwardRef as ReactComponent };